export enum AidFrontendFeatureGate {
  // Stable test-only entry. Use this in unit tests so they don't break when real gates are added or removed.
  TEST_GATE = 'test_gate',
  // https://switcheroo.atlassian.com/ui/gates/c2e09b58-639a-4260-89de-4b390ac2b746/key/identity-aid-frontend-sms-enrollment-new-captcha
  // https://hello.atlassian.net/wiki/spaces/I/pages/4492639544/22-11-2025+Current+State+of+UniCAPTCHA+rollout
  SMS_ENROLLMENT_UNICAPTCHA = 'identity-aid-frontend-sms-enrollment-new-captcha',
  // !! IMPORTANT !! Make sure to update integration test mocks to use the new endpoints when this is updated/removed/added
  // https://switcheroo.atlassian.com/ui/gates/fc7e9434-0ffa-46ba-9831-43c4cba66cdc/key/id-frontend-use-state-data-loaders
  USE_STATE_DATA_LOADERS = 'id-frontend-use-state-data-loaders',
  // https://switcheroo.atlassian.com/ui/gates/e2f249e8-68ad-46fe-8617-c903b90bf375/key/kirby-7873_new_json_endpoint_for_verify-email
  ENABLE_JSON_ENDPOINT_FOR_VERIFY_EMAIL = 'kirby-7873_new_json_endpoint_for_verify-email',
  // https://switcheroo.atlassian.com/ui/gates/e453edbd-fac6-473a-9c80-8f0f65225db3/key/twcg-786-prioritise-sso-gate
  TWCG_786_PRIORITISE_SSO_ON_LOGIN_PAGE_GATE = 'twcg-786-prioritise-sso-gate',
  // https://switcheroo.atlassian.com/ui/gates/a565fcb4-3217-46f8-805d-b457c3b9f765/key/twcg-786-prioritise-sso-on-login-page
  TWCG_786_PRIORITISE_SSO_ON_LOGIN_PAGE = 'twcg-786-prioritise-sso-on-login-page',
  CFIND_4831_PRODUCT_OVERLAY_MODAL_VISUAL_UPDATES = 'cfind_4831_product_overlay_modal_visual_updates',
  // https://switcheroo.atlassian.com/ui/gates/8448999d-2aa7-4b02-9d30-08f8cca46365/key/id-frontend-enable-aws-waf-captcha
  ENABLE_AWS_WAF_CAPTCHA = 'id-frontend-enable-aws-waf-captcha',
  // https://switcheroo.atlassian.com/ui/gates/173e80a9-c83a-473c-b04a-52e10980b2c1/key/id-frontend-remove-recaptcha-tos-references
  REMOVE_RECAPTCHA_TOS_REFS = 'id-frontend-remove-recaptcha-tos-references',
  CFIND_5480_TWC_SIGNUP_OVERLAY = 'cfind-5480-twc-signup-overlay',
}

export enum AidFrontendExperiment {
  // Stable test-only entry. Use this in unit tests so they don't break when real experiments are added or removed.
  TEST_EXPERIMENT = 'test_experiment',
  // https://switcheroo.atlassian.com/ui/gates/6bfb6ca5-bcb2-436e-af68-ca7bbff05426/key/ghost_advanced_cobranding_direct_signup
  GHOST_ADVANCED_COBRANDING_DIRECT_SIGNUP = 'ghost_advanced_cobranding_direct_signup',
}
